import { render, staticRenderFns } from "./serverManage.vue?vue&type=template&id=7f85667d&"
import script from "./serverManage.vue?vue&type=script&lang=js&"
export * from "./serverManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports